import React, { forwardRef } from 'react'
import { Input } from '@ow/comps'

export default forwardRef(({ opts = {}, value, style, onChange }, ref) => {
  const { fieldIsDisabled } = opts
  return (
    <Input
      ref={ref}
      {...opts}
      style={{
        height: '100%',
        width: '132px',
        ...style,
      }}
      disabled={fieldIsDisabled}
      className="right-input"
      placeholder={opts.hint || `请输入${opts.title}`}
      onChange={(e) => {
        if (onChange) {
          onChange(e.target.value)
        }
      }}
      value={value}
    />
  )
})
